import React, { useState, useEffect, useRef }   from 'react';
import axios                                    from 'axios';
import ContactsList                             from './ContactsList';
import MessagesList                             from './MessagesList';
import MessageInput                             from './MessageInput';
import { useLocation }                          from 'react-router-dom';
import { useTranslation }                       from 'react-i18next';


import { 
    Box,
    Container, 
    Divider, 
    Typography 
} from '@mui/material';
import ApiService from '../../components/service/ApiService';

const ChatPageSAT = () => {
    const location = useLocation();
    const { t } = useTranslation();

    
    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const idSAT = user?.id;

    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
    };

    const [contacts,            setContacts         ] = useState([]);
    const [activeChat,          setActiveChat       ] = useState(location.state?.contact || null);
    const [chatHistory,         setChatHistory      ] = useState([]);
    const [newMessage,          setNewMessage       ] = useState('');
    const [loading,             setLoading          ] = useState(false);
    const [idDestinatario,      setDestinatario     ] = useState([]);


    const chatEndRef = useRef(null);    

    // Fetch contatti all'avvio e carica l'ultima chat se esiste
    const fetchContacts = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`messaggio/elenco?id=${idSAT}&tipo=1`, { headers: headers });
            // const response = await ApiService.request("elencoMessaggi", { id: idSAT, tipo: 1});
            if (response.data && Array.isArray(response.data.messaggi)) {
                const groupedContacts = {};

                response.data.messaggi.forEach((msg) => {
                    const { idReso } = msg;
                    if (!groupedContacts[idReso] && (msg.chiuso === false || msg.chiuso === null)) {
                        groupedContacts[idReso] = {
                            id:             msg?.id,
                            idReso:         idReso,
                            ragioneSociale: msg?.ragioneSocialeCliente,
                            messaggi:       [],
                        };
                    }
                    if (msg.chiuso === false || msg.chiuso === null) {
                    groupedContacts[idReso].messaggi.push({
                        from:   msg.testi[0]?.idMittente,
                        to:     msg.testi[0]?.idDestinatario,
                        text:   msg.testi[0]?.descrizione,
                        date:   msg.testi[0]?.data,
                        id:     msg.id,
                        idReso: msg.idReso
                    });
                }
                });
    
                const uniqueContacts = Object.values(groupedContacts);
                setContacts(uniqueContacts);

            // Se arrivo da AvvisiTable, imposto la chat selezionata come activeChat
            if (location.state?.isNavigatingFromAvvisi) {
                const selectedChat = uniqueContacts.find(
                    contact => contact.idReso === location.state.contact.idReso
                );
                if (selectedChat) {
                    setActiveChat(selectedChat);
                    setChatHistory(selectedChat.messaggi);
                }
            } else {
                const lastChatId = sessionStorage.getItem("lastChatId");
                const lastChat = uniqueContacts.find(contact => contact.idReso === parseInt(lastChatId));
                if (lastChat) {
                    setActiveChat(lastChat);
                    setChatHistory(lastChat.messaggi);
                }
            }
        }
        } catch (error) {
            console.error("Errore nel recupero dei contatti:", error);
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        fetchContacts();
    }, []);


   // Fetch della cronologia dei messaggi quando si seleziona una chat
    const fetchChatHistory = async (chatId, idReso) => {
        try {
            const response = await axios.get(`messaggio/${chatId}`, { headers: headers });
            if (response.data && response.data.idReso === idReso) {
                const history = response.data.testi.map((msg) => ({
                    from:   msg?.idMittente,
                    to:     msg?.idDestinatario,
                    text:   msg?.descrizione,
                    date:   msg?.data,
                    id:     msg?.id,
                    idReso: msg?.idReso,
                    idMittente: msg?.idMittente
                }));
                setChatHistory(history);
                setDestinatario(response.data.idCliente);
            }
        } catch (error) {
            console.error("Errore nel caricamento della cronologia chat:", error);
        }
    };


    const handleContactClick = (contact) => {    
        //nel caso in cui creassi una nuova chat, salvo un messaggio ma ovviamente non rieseguo il fetch, quindi l'id della chat ancora non ce l'ho nel contact, allora lo prendo dal sessionStorage    
        const storedContacts = JSON.parse(sessionStorage.getItem("contacts")) || [];
        const storedContact = storedContacts.find((stored) => stored.idReso === contact.idReso);
    
        if (storedContact && storedContact.id && !contact.id) {
            contact = { ...contact, id: storedContact.id };
        }
        setActiveChat(contact);
        fetchChatHistory(contact?.id, contact?.idReso);
    };

    
        // useEffect per Aggiungere il contatto inviato da TabellaDashboardSAT solo se non è già presente
        useEffect(() => {
            const newContact = location.state?.contact;
            const isFromAvvisi = location.state?.isNavigatingFromAvvisi;
    
            if (newContact) {
                const contactExists = contacts.some(contact => contact.idReso === newContact.idReso);
                if (!contactExists) {
                    const updatedContacts = [...contacts, newContact];
                    setContacts(updatedContacts);
                }
                setActiveChat(newContact); 
                if (isFromAvvisi) {
                    fetchChatHistory(newContact.id, newContact.idReso);
                }
            }
        }, [location.state, contacts]);    

        const handleSend = async () => {
            const now     = new Date();
            const day     = String(now.getDate()).padStart(2, '0');
            const month   = String(now.getMonth() + 1).padStart(2, '0'); // Perché i mesi in JavaScript vanno da 0 a 11
            const year    = now.getFullYear();
            const hours   = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const id      = activeChat?.id || null;        

            const datiMessaggio = {
            tipo:           1, // 1 per la chat, 0 per gli avvisi
            idMittente:     idSAT,
            idDestinatario: idDestinatario || location?.state?.contact?.idCliente,
            testo:          newMessage,
            idReso:         activeChat?.idReso || location?.state?.contact?.idReso,
            id:             id,
            data:           (`${day}/${month}/${year} ${hours}:${minutes}`).replace(/%2F/g, "/")
            };
        
            const urlMessaggio = "/messaggio/salva";

            try {
                const responseSendMessaggio = await axios.post(urlMessaggio, datiMessaggio, { headers: headers });
                // const responseSendMessaggio = await ApiService.request("saveMessage", {}, datiMessaggio);
                if (responseSendMessaggio.data) {
                    // Se è il primo messaggio aggiorno l'id della chat
                    if (!activeChat?.id) {                        
                        const newChatId = responseSendMessaggio.data;
        
                        setActiveChat((prevChat) => {
                            const updatedChat = { ...prevChat, id: newChatId };
                            const storedContacts = JSON.parse(sessionStorage.getItem("contacts")) || [];
                            const updatedContacts = storedContacts.map(contact =>
                                contact.idReso === activeChat.idReso ? { ...contact, id: newChatId } : contact
                            );
                            sessionStorage.setItem("contacts", JSON.stringify(updatedContacts));
                            return updatedChat; 
                        });
                    }
                        setChatHistory((prevHistory) => [
                        ...prevHistory,
                        {
                            from:   datiMessaggio?.idMittente,
                            to:     datiMessaggio?.idDestinatario,
                            text:   newMessage,
                            date:   datiMessaggio?.data,
                            id:     datiMessaggio?.id,
                            idReso: datiMessaggio?.idReso
                        }
                    ]);
                    setNewMessage('');
                }
            } catch (error) {
                console.error("Errore durante l'invio del messaggio!", error);
            }
        };

        useEffect(() => {
            const storedContacts = JSON.parse(sessionStorage.getItem("contacts"));
            if (storedContacts) {
                const updatedChat = storedContacts.find(contact => contact.idReso === activeChat?.idReso);
                if (updatedChat && updatedChat.id !== activeChat?.id) {
                    setActiveChat(updatedChat);
                }
            }
        }, [activeChat?.idReso]);

        const handleArchive = async (contact) => {
            const id = contact?.id;
            
            try {
                // const responseArchive = await axios.post(`http://localhost:8080/messaggio/chiudi?id=${id}`, {}, { headers: headers});
                const responseArchive = await ApiService.request("messaggioChiudi", {id: id});
                if (responseArchive.data === "OK") {
                    fetchContacts();
                }
            } catch(error) {
                console.error("errore durante l'archiviazione della chat", error);
            }
        };
        

    return (
        <Container maxWidth="false" sx={{ display: 'flex', height: 'calc(100vh - 110px)'}}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    borderRadius: '20px',
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                }}
            >
            <Box 
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderRight: '1px solid #e0e0e0',
                    bgcolor: '#f5f5f5',
                    borderRadius: '20px 0px 0px 20px',
                    height: '100%'
                }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '2em', m: 2, color: '#FDA03D'}}>Chat</Typography>
            <Divider sx={{ width: '100%', border: 'solid 0.5px #E0E0E0' }} />
            <ContactsList 
                contacts={contacts} 
                onContactClick={handleContactClick} 
                onArchive={handleArchive}
            />
            </Box>
            {activeChat && (
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Box sx={{ flex: 1, overflowY: 'auto' }}>
                        <MessagesList 
                        messages={chatHistory} 
                        activeChat={activeChat}
                        loading={loading}
                        idSAT={idSAT}
                        />
                        <Box ref={chatEndRef} />
                    </Box>
                    <MessageInput
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        onSend={handleSend}
                    />
                </Box>
            )}
            </Box>
        </Container>
    );
};

export default ChatPageSAT;
